import { createContext, ReactNode, useContext } from 'react';
import { UpgradeConfigKey } from '../types/game-types';

export const GeneratorContext = createContext<UpgradeConfigKey | null>(null);

export const GeneratorContextProvider = ({ value, children }: { value: UpgradeConfigKey; children: ReactNode }) => {
  return <GeneratorContext.Provider value={value}>{children}</GeneratorContext.Provider>;
};

export const useGeneratorContext = () => {
  const context = useContext(GeneratorContext);

  if (!context) {
    throw new Error('useGeneratorContext should be used inside a GeneratorContextProvider.');
  }

  return context;
};
